import React from 'react'
import { Link as GatsbyLink } from 'gatsby'
import styled from 'styled-components'
import media from '../styles/media'
import Colors from '../styles/Colors'
import { StrikeThroughTransparentStyles } from './Text'

type Props = {
  setImageState: any
  menuOpen: boolean
  isDarkMode?: boolean
}

const HeaderVert: React.FC<Props> = ({
  setImageState,
  menuOpen,
  isDarkMode,
}) => {
  return (
    <Wrapper className="vert-header" open={menuOpen} isDarkMode={isDarkMode}>
      <Menu
        open={menuOpen}
        className="vert-header__menu-wrap"
        onMouseLeave={() => setImageState(0)}
      >
        <Home className="vert-header__home" open={menuOpen}>
          <Link
            style={{
              backgroundColor: isDarkMode
                ? Colors.whiteSmoke
                : Colors.softBlack,
              WebkitTextStrokeColor: isDarkMode
                ? Colors.whiteSmoke
                : Colors.softBlack,
            }}
            to="/"
            onMouseEnter={() => setImageState(1)}
          >
            Home
          </Link>
        </Home>
        <About className="vert-header__about" open={menuOpen}>
          <Link
            style={{
              backgroundColor: isDarkMode
                ? Colors.whiteSmoke
                : Colors.softBlack,
              WebkitTextStrokeColor: isDarkMode
                ? Colors.whiteSmoke
                : Colors.softBlack,
            }}
            to="/about"
            onMouseEnter={() => setImageState(2)}
          >
            About
          </Link>
        </About>
        <Products className="vert-header__products" open={menuOpen}>
          <Link
            style={{
              backgroundColor: isDarkMode
                ? Colors.whiteSmoke
                : Colors.softBlack,
              WebkitTextStrokeColor: isDarkMode
                ? Colors.whiteSmoke
                : Colors.softBlack,
            }}
            to="/products"
            onMouseEnter={() => setImageState(3)}
          >
            Products{' '}
          </Link>
        </Products>
        <Resources className="vert-header__resources" open={menuOpen}>
          <Link
            style={{
              backgroundColor: isDarkMode
                ? Colors.whiteSmoke
                : Colors.softBlack,
              WebkitTextStrokeColor: isDarkMode
                ? Colors.whiteSmoke
                : Colors.softBlack,
            }}
            to="/resources"
            onMouseEnter={() => setImageState(4)}
          >
            Resources
          </Link>
        </Resources>
        <Careers className="vert-header__careers" open={menuOpen}>
          <OutBoundLink
            style={{
              backgroundColor: isDarkMode
                ? Colors.whiteSmoke
                : Colors.softBlack,
              WebkitTextStrokeColor: isDarkMode
                ? Colors.whiteSmoke
                : Colors.softBlack,
            }}
            href="https://jobs.rtr.ai/ax.do?refresh=true&portalGK=35055"
            target="__blank"
            rel="noopener noreferrer"
            onMouseEnter={() => setImageState(5)}
          >
            Careers
          </OutBoundLink>
        </Careers>
        <Contact className="vert-header__contact" open={menuOpen}>
          <Link
            style={{
              backgroundColor: isDarkMode
                ? Colors.whiteSmoke
                : Colors.softBlack,
              WebkitTextStrokeColor: isDarkMode
                ? Colors.whiteSmoke
                : Colors.softBlack,
            }}
            to="/products/#contact"
            onMouseEnter={() => setImageState(6)}
          >
            Contact
          </Link>
        </Contact>
      </Menu>
    </Wrapper>
  )
}

const Wrapper = styled.div<{ open: boolean; isDarkMode: boolean }>`
  position: fixed;
  top: 96px;
  width: ${(props) => (props.open ? '839px' : '95px')};
  overflow: hidden;
  transition-property: width;
  transition-timing-function: ${(props) =>
    props.open
      ? 'cubic-bezier(0.12, 1, 0.72, 1)'
      : 'cubic-bezier(0.72, 0, 0.12, 1)'};
  transition-duration: ${(props) => (props.open ? '800ms' : '1000ms')};
  height: calc(100vh - 95px);
  z-index: 999;
  right: 0;
  background: ${(props) =>
    props.isDarkMode ? Colors.softBlack : Colors.whiteSmoke};
  border-left: 1px solid
    ${(props) => (props.isDarkMode ? Colors.whiteSmoke : Colors.softBlack)};
  ${media.tabletLandscape} {
    width: ${(props) => (props.open ? '839px' : '0px')};
    top: 48px;
    height: calc(100vh - 48px);
    right: -1px;
  }
  ${media.tablet} {
    width: ${(props) => (props.open ? '96.8vw' : '0px')};
  }
`
const Menu = styled.nav<{ open: boolean }>`
  position: absolute;
  top: 122px;
  right: ${(props) => (props.open ? '435px' : '-355px')};
  transition-timing-function: cubic-bezier(0.12, 1, 0.72, 1);
  transition-duration: ${(props) => (props.open ? '800ms' : '0ms')};
  transition-delay: ${(props) => (props.open ? '0ms' : '1000ms')};
  display: flex;
  flex-direction: column;
  width: 260px;

  ${media.tablet} {
    right: ${(props) => (props.open ? 'calc(96.8vw - 308px)' : '-355px')};
    height: calc(100vh - 48px);
    padding-bottom: 48px;
    top: 48px;
  }
  ${media.mobile} {
    overflow: scroll;
  }
`

const Link = styled(GatsbyLink)`
  font-size: 54px;
  line-height: 56px;
  font-weight: 500;
  width: fit-content;
  ${StrikeThroughTransparentStyles}
  :hover {
    background-color: rgba(0, 0, 0, 0) !important;
  }
  ${media.mobile} {
    font-size: 36px;
    line-height: 36px;
  }
`

const OutBoundLink = styled.a`
  font-size: 54px;
  line-height: 56px;
  font-weight: 500;
  width: fit-content;
  ${StrikeThroughTransparentStyles}
  :hover {
    background-color: rgba(0, 0, 0, 0) !important;
  }
  ${media.mobile} {
    font-size: 36px;
    line-height: 36px;
  }
`

const LinkContainer = styled.div<{ open: boolean }>`
  margin-bottom: 48px;
  width: 260px;
  transition-timing-function: cubic-bezier(0.12, 1, 0.72, 1);
  transition-duration: ${(props) => (props.open ? '800ms' : '0ms')};
  transition-delay: ${(props) => (props.open ? '0ms' : '1000ms')};
  height: 56px;
  ${media.mobile} {
    height: 36px;
  }
`

const Home = styled(LinkContainer)<{ open: boolean }>`
  ${media.tablet} {
  }
`
const About = styled(LinkContainer)<{ open: boolean }>`
  margin-left: ${(props) => (props.open ? 0 : '192px')};
  ${media.tablet} {
  }
`
const Products = styled(LinkContainer)<{ open: boolean }>`
  margin-left: ${(props) => (props.open ? 0 : '391px')};
  ${media.tablet} {
  }
`
const Resources = styled(LinkContainer)<{ open: boolean }>`
  margin-left: ${(props) => (props.open ? 0 : '576px')};
  ${media.tablet} {
  }
`
const Careers = styled(LinkContainer)<{ open: boolean }>`
  margin-left: ${(props) => (props.open ? 0 : '768px')};
  ${media.tablet} {
  }
`
const Contact = styled(LinkContainer)<{ open: boolean }>`
  margin-left: ${(props) => (props.open ? 0 : '960px')};
  ${media.tablet} {
  }
`

export default HeaderVert
